import React from 'react';
import {
  Code2,
  GitBranch,
  Eye,
  Sparkles,
  DollarSign,
  Type,
  AlignLeft,
  Table as TableIcon,
  FileText,
  CornerDownLeft,
  Edit3,
} from './icons';

export function SyntaxCategoryList({
  categories,
  activeCategoryId,
  onSelectCategory,
  searchQuery = '',
  itemCountsByCat = {},
}) {
  const renderIcon = (iconType) => {
    switch ((iconType || '').toLowerCase()) {
      case 'code':
        return <Code2 size={16} strokeWidth={2.2} />;
      case 'optional':
        return <Eye size={16} strokeWidth={2.2} />;
      case 'branch':
        return <GitBranch size={16} strokeWidth={2.2} />;
      case 'clear':
        return <Sparkles size={16} strokeWidth={2.2} />;
      case 'dollar':
        return <DollarSign size={16} strokeWidth={2.2} />;
      case 'type':
        return <Type size={16} strokeWidth={2.2} />;
      case 'align':
        return <AlignLeft size={16} strokeWidth={2.2} />;
      case 'table':
        return <TableIcon size={16} strokeWidth={2.2} />;
      case 'file':
        return <FileText size={16} strokeWidth={2.2} />;
      case 'corner-down-left':
        return <CornerDownLeft size={16} strokeWidth={2.2} />;
      case 'pen':
        return <Edit3 size={16} strokeWidth={2.2} />;
      default:
        return <Code2 size={16} strokeWidth={2.2} />;
    }
  };

  return (
    <nav className="syntax-category-nav" aria-label="Syntax Help Categories">
      {categories.map((cat) => {
        const isActive = cat.id === activeCategoryId;
        const matchCount = itemCountsByCat[cat.id];
        return (
          <button
            key={cat.id}
            type="button"
            className={`syntax-category-item-btn ${isActive ? 'active' : ''}`}
            onClick={() => onSelectCategory(cat.id)}
            aria-current={isActive ? 'true' : 'false'}
          >
            <span className="syntax-category-icon-wrapper">
              {renderIcon(cat.iconType)}
            </span>
            <span className="syntax-category-item-label">{cat.name}</span>
            {searchQuery && matchCount > 0 && (
              <span className="syntax-category-match-pill">{matchCount}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
